export const terminationType : { value: string; label: string }[] = [
    { value: "Select", label: "Select" },
    { value: "Voluntary", label: "Voluntary" },
    { value: "Involuntary", label: "Involuntary" },
    { value: "Layoff", label: "Layoff" },
    { value: "Contract End", label: "Contract End" },
    { value: "Retirement", label: "Retirement" },
    { value: "Mutual Agreement", label: "Mutual Agreement" },
    { value: "Termination for Cause", label: "Termination for Cause" },
    { value: "Redundancy", label: "Redundancy" },
    { value: "Misconduct", label: "Misconduct" },
    { value: "Performance-Based", label: "Performance-Based" },
  ];
  